import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RequestMoneyService } from '../request-money.service';

@Component({
  selector: 'app-request-step2',
  templateUrl: './request-step2.component.html',
  styleUrls: ['./request-step2.component.scss']
})
export class RequestStep2Component implements OnInit  {
  @ViewChild('requestForm') requestForm: NgForm;
  constructor(public requestMoneyervice:RequestMoneyService) { }

  ngOnInit(): void {
    if(!this.requestMoneyervice.step1Data){
      this.requestMoneyervice.goTo("step1")
    }
    setTimeout(() => {
      if(this.requestMoneyervice.step2Data){
        this.requestForm.setValue(this.requestMoneyervice.step2Data)
      }
   }, );
  }



  goNext(){
    this.requestMoneyervice.step2Data=this.requestForm.value
    this.requestMoneyervice.goTo('step3')
  }

  goBack(){
    this.requestMoneyervice.goTo('step1')
  }

}
